import { values, path, is, forEach, lensPath, view, isEmpty, isNil, pluck, pathOr } from "ramda";
import { capitalize, lowerCase } from "lodash";

import { set } from "utils/storeUtils";

import { camelize } from "./keysConverter";

export const isNotFound = (error) => {
  return path(["response", "status"], error) === 404;
};

export const isUnauthorized = (error) => {
  return path(["response", "status"], error) === 401;
};

export const isUnprocessableEntity = (error) => {
  return path(["response", "status"], error) === 422;
};

export const isLocked = (error) => {
  return path(["response", "status"], error) === 423;
};

const isFormikError = (error) => is(Error, error) && error.name === "ValidationError";

export const hasErrorAt = (errors, lens) => {
  return !!view(lensPath(lens), errors);
};

export const errorValueAt = (errors, lens) => {
  return view(lensPath(lens), errors);
};

export const yupToFormErrors = (yupErrors) => {
  let errors = {};

  const formatError = (err) => {
    if (!errors[err.path]) {
      const fieldName = err.path;
      const formattedFieldName = capitalize(lowerCase(fieldName));
      const error = err.message.replace(fieldName, formattedFieldName);

      errors = set(errors, err.path.split("."), error);
    }
  };

  if (isEmpty(yupErrors.inner)) {
    formatError(yupErrors);
  } else {
    const yupErrorsValues = values(yupErrors.inner);
    forEach(formatError, yupErrorsValues);
  }

  return errors;
};

export const apiErrorsToFormik = (error) => {
  const errors = pathOr("", ["response", "data", "errors"], error);

  if (isNil(errors) || isEmpty(errors)) return "";
  const camelizedErrors = camelize(errors);
  if (isUnprocessableEntity(error)) {
    return pluck("detail")(camelizedErrors).join(", ");
  }

  return Object.keys(camelizedErrors).reduce((acc, key) => ({ ...acc, [key]: camelizedErrors[key].join(", ") }), {});
};

export const toCommonErrorInterface = (errors) => {
  if (isFormikError(errors)) {
    return yupToFormErrors(errors);
  }
  return errors;
};

export const handleErrors = (err, handler) => {
  const commonErrors = toCommonErrorInterface(err);
  handler(commonErrors);
};

export const getIndexedErrorText = (errors, association, index, key) => {
  const errorKey = `${association}[${index}].${key}`;
  return pathOr(null, [errorKey], errors);
};
